<template>
  <div class="w-full">
    <BackButton v-if="isHidden" class="px-5 md:px-6 lg:px-8" :custom-back="back" />
  </div>
</template>

<script>
import BackButton from '@/components/common/BackButton.vue';
import DirectedNavigation from '@/mixins/DirectedNavigation';
import { BOOT_ONLY_PATHS } from '@/utils/deeplink';

export default {
  components: {
    BackButton,
  },
  mixins: [DirectedNavigation],
  props: {
    isHidden: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /**
     * Back out of a sermon to wherever the reader actually came from.
     *
     * A sermon is reachable from more than the Library — a Next Steps lesson can
     * link to one with an INTERNAL_PAGE banner — so this cannot name a single
     * origin. It used to: Home, or anything-else-means-Library, which dropped a
     * reader who arrived from a lesson onto the Library TAB.
     *
     * Popping the stack is the right default, but "is there a stack?" cannot be
     * answered with `window.history.length > 1` (what BackButton's own default
     * uses). A native sermon link is `router.push`ed on top of whatever startup
     * route the app was showing, so on a cold open history is already deeper than
     * one and a pop lands the member on `/pre-sign-in`. `previousRoutePath()`
     * answers what is actually behind us, which is the part that matters.
     */
    back() {
      const behind = this.previousRoutePath();
      if (behind && !BOOT_ONLY_PATHS.has(behind)) {
        this.goBack();
        return;
      }
      // Cold open: something is behind us, but nowhere a member should be sent.
      // Replace rather than push, so Back from the Library does not come back here.
      this.$router.replace('/library');
    },
  },
};
</script>
